(function () {
  var trackNL = function (evtName, props) {
    if (typeof nolimit !== "undefined" && nolimit.track) {
      if (props) {
        nolimit.track(evtName, props);
      } else {
        nolimit.track(evtName);
      }
    }
  };

  // Test for Safari private browsing mode
  try {
    localStorage.test = 2;
  } catch {
    trackNL("Safari Private Browsing");
  }

  var $searchForm = $("form#search-form");
  const checkFormValidation = function (form, validator) {
    var errors = validator.numberOfInvalids();
    if (errors > 0) {
      $(form).addClass("with-errors");
    } else {
      $(form).removeClass("with-errors");
    }
  };

  $.validator.addMethod(
    "atLeastOneLetter",
    function (value) {
      return /[a-z]+/i.test(value);
    },
    "Alphabetic characters required",
  );

  $.validator.addMethod(
    "notEmail",
    function (value, element) {
      /* eslint-disable */
      return (
        this.optional(element) ||
        !/^[ a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[ a-zA-Z0-9](?:[ a-zA-Z0-9-]{0,61}[ a-zA-Z0-9])?(?:\.[ a-zA-Z0-9](?:[ a-zA-Z0-9-]{0,61}[ a-zA-Z0-9])?)*$/.test(
          value,
        )
      );
      /* eslint-enable */
    },
    "Email addresses are not searchable here",
  );

  $.validator.addMethod(
    "noEmptySpacesOnly",
    function (value) {
      return value === "" || 0 !== value.trim().length;
    },
    "Empty/blank search not allowed",
  );

  $.validator.addMethod(
    "emptyOrletters",
    function (value) {
      return (
        (value.trim() !== "" && /[a-z]+/i.test(value)) || value.trim() === ""
      );
    },
    "Alphabetic characters required",
  );

  $.validator.addMethod(
    "numbersOrEmpty",
    function (value) {
      return (
        value.trim() === "" || ("" !== value.trim() && /^[0-9]+$/.test(value))
      );
    },
    "Alphabetic characters required",
  );

  if ($searchForm.length !== 0) {
    $searchForm.each(function () {
      $(this).validate({
        rules: {
          fn: {
            required: true,
            notEmail: true,
            noEmptySpacesOnly: true,
            atLeastOneLetter: true,
          },
          ln: {
            required: true,
            notEmail: true,
            noEmptySpacesOnly: true,
            atLeastOneLetter: true,
          },
          mi: {
            notEmail: true,
          },
          age: {
            notEmail: true,
            numbersOrEmpty: true,
          },
          city: {
            notEmail: true,
          },
        },
        messages: {
          fn: "Please enter a first name",
          ln: "Please enter a last name",
          mi: "Please enter valid middle name",
          city: "Please enter a valid city",
        },
        validClass: "success",
        onkeyup: false,
        onclick: false,
        onsubmit: true,
        submitHandler: function (form, e) {
          e.preventDefault();
          trackNL("Submitted Search Form - People");
          window.setTimeout(function () {
            form.submit();
          }, 300);
        },
        invalidHandler(event, validator) {
          checkFormValidation(this, validator);
        },
        highlight: function (element, errorClass, validClass) {
          $(element).parent().addClass(errorClass).removeClass(validClass);
          checkFormValidation(element.form, this);
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).parent().removeClass(errorClass).addClass(validClass);
          checkFormValidation(element.form, this);
        },
      });
    });
  }

  $(".result-row").on("click", function (e) {
    if (e.currentTarget.hasAttribute("href")) {
      var url = e.currentTarget.getAttribute("href");
      window.location = url;
    } else {
      return;
    }
  });

  $("#cities__collapse__button").on("click", function () {
    $(this).hide();
    $("#cities__collapse__filter").collapse("show");
  });

  function throttle(fn, wait) {
    let time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
  }
  function backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  window.addEventListener("scroll", throttle(scrollFunction, 50));
  function scrollFunction() {
    if (
      document.body.scrollTop > 670 ||
      document.documentElement.scrollTop > 670
    ) {
      $("#back-to-top-btn").show();
    } else {
      $("#back-to-top-btn").hide();
    }
  }
  $("#back-to-top-btn").on("click", backToTop);
})();
